import axiosApi from '../../../../Shared/api/axiosApi';

class MerchZoneApi {
    static getMerchZone(requestUrl) {
        return axiosApi.get(requestUrl, false).then(response => {
            return response;
        }).catch(error => {
            throw error;
        });
    }
}

export default MerchZoneApi;